/**
 * Direction lock for Glide carousels on mobile.
 * Horizontal-first inside the carousel; vertical page scroll is allowed only
 * when vertical movement clearly exceeds a threshold before horizontal lock.
 * Once locked horizontal, the gesture stays horizontal until touchend.
 */
(function() {
  var ACTIVATION_PX = 4;
  var HORIZONTAL_LOCK_PX = 3;
  var HORIZONTAL_DOMINANCE = 1.05;
  var VERTICAL_ESCAPE_PX = 45;
  var VERTICAL_DOMINANCE = 1.6;
  var LOCK_CLASS = 'hh-glide-touch-lock--horizontal';
  var MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  var bindings = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  var fallbackBindings = [];

  function getTouch(event) {
    if (event.touches && event.touches.length) return event.touches[0];
    if (event.changedTouches && event.changedTouches.length) return event.changedTouches[0];
    return null;
  }

  function isMobile() {
    return MOBILE_MQ.matches;
  }

  function isVerticalIntent(absX, absY) {
    return absY >= VERTICAL_ESCAPE_PX && absY > absX * VERTICAL_DOMINANCE;
  }

  function isHorizontalIntent(absX, absY) {
    return absX >= HORIZONTAL_LOCK_PX && absX >= absY * HORIZONTAL_DOMINANCE;
  }

  function getBinding(el) {
    if (bindings) return bindings.get(el);
    for (var i = 0; i < fallbackBindings.length; i++) {
      if (fallbackBindings[i].el === el) return fallbackBindings[i];
    }
    return null;
  }

  function setBinding(el, state) {
    if (bindings) {
      bindings.set(el, state);
      return;
    }
    for (var i = 0; i < fallbackBindings.length; i++) {
      if (fallbackBindings[i].el === el) {
        fallbackBindings[i] = state;
        return;
      }
    }
    fallbackBindings.push(state);
  }

  function removeBinding(el) {
    if (bindings) {
      bindings.delete(el);
      return;
    }
    fallbackBindings = fallbackBindings.filter(function(item) {
      return item.el !== el;
    });
  }

  function clearLock(state) {
    state.axis = null;
    if (state.el) state.el.classList.remove(LOCK_CLASS);
  }

  function resetState(state) {
    clearLock(state);
    state.startX = 0;
    state.startY = 0;
  }

  function lockHorizontal(state) {
    state.axis = 'x';
    state.el.classList.add(LOCK_CLASS);
  }

  function onTouchStart(state, event) {
    if (!isMobile()) return;
    var touch = getTouch(event);
    if (!touch) return;
    resetState(state);
    state.startX = touch.pageX;
    state.startY = touch.pageY;
  }

  function onTouchMove(state, event) {
    if (!isMobile()) return;
    var touch = getTouch(event);
    if (!touch) return;

    var dx = touch.pageX - state.startX;
    var dy = touch.pageY - state.startY;
    var absX = Math.abs(dx);
    var absY = Math.abs(dy);

    if (!state.axis) {
      if (absX < ACTIVATION_PX && absY < ACTIVATION_PX) return;

      if (isVerticalIntent(absX, absY)) {
        state.axis = 'y';
        return;
      }

      if (isHorizontalIntent(absX, absY)) {
        lockHorizontal(state);
      } else {
        return;
      }
    }

    if (state.axis === 'x') {
      event.preventDefault();
    }
  }

  function onTouchEnd(state) {
    resetState(state);
  }

  function bind(el) {
    if (!el || getBinding(el)) return;

    var state = {
      el: el,
      axis: null,
      startX: 0,
      startY: 0,
      onTouchStart: function(event) { onTouchStart(state, event); },
      onTouchMove: function(event) { onTouchMove(state, event); },
      onTouchEnd: function() { onTouchEnd(state); }
    };

    el.addEventListener('touchstart', state.onTouchStart, { passive: true, capture: true });
    el.addEventListener('touchmove', state.onTouchMove, { passive: false, capture: true });
    el.addEventListener('touchend', state.onTouchEnd, { passive: true, capture: true });
    el.addEventListener('touchcancel', state.onTouchEnd, { passive: true, capture: true });

    setBinding(el, state);
  }

  function unbind(el) {
    if (!el) return;
    var state = getBinding(el);
    if (!state) return;

    el.removeEventListener('touchstart', state.onTouchStart, true);
    el.removeEventListener('touchmove', state.onTouchMove, true);
    el.removeEventListener('touchend', state.onTouchEnd, true);
    el.removeEventListener('touchcancel', state.onTouchEnd, true);
    resetState(state);
    removeBinding(el);
  }

  window.HHGlideTouchLock = {
    bind: bind,
    unbind: unbind
  };
})();
